import { Link, NavLink, Outlet } from 'react-router-dom'
import { Logo } from './Logo'
import { ButtonLink } from '../ui/Button'

const navigation = [
  { to: '/how-it-works', label: 'How it works' },
  { to: '/for-units', label: 'For units' },
  { to: '/account', label: 'My account' },
]

/** Chrome for the pages a customer or prospective unit sees before signing in. */
export function PublicLayout() {
  return (
    <div className="flex min-h-dvh flex-col">
      <header className="sticky top-0 z-40 border-b border-[color:var(--surface-border)] bg-[color:var(--surface-raised)]/85 backdrop-blur">
        <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4 sm:px-6">
          <Link to="/" className="flex items-center gap-2.5 text-forest-700 dark:text-forest-200">
            <Logo />
            <span className="text-lg font-semibold tracking-tight text-[color:var(--text-strong)]">
              Holiday Flags
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex" aria-label="Main">
            {navigation.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  [
                    'rounded-lg px-3 py-2 text-sm font-medium transition',
                    isActive
                      ? 'bg-[color:var(--surface-sunken)] text-[color:var(--text-strong)]'
                      : 'text-[color:var(--text-muted)] hover:text-[color:var(--text-strong)]',
                  ].join(' ')
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <ButtonLink to="/sign-in" variant="secondary" size="sm">
            Unit sign in
          </ButtonLink>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-[color:var(--surface-border)] bg-[color:var(--surface-raised)]">
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-4 px-4 py-8 text-sm text-[color:var(--text-muted)] sm:flex-row sm:items-center sm:justify-between sm:px-6">
          <p>Holiday Flags helps Scout units run their yearly flag fundraiser.</p>
          <nav className="flex gap-4" aria-label="Footer">
            <Link to="/contact" className="hover:text-[color:var(--text-strong)]">
              Contact
            </Link>
            <Link to="/privacy" className="hover:text-[color:var(--text-strong)]">
              Privacy
            </Link>
          </nav>
        </div>
      </footer>
    </div>
  )
}
